import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import NumberFormatComp from '@Components/Common/NumberFormatComp';
import { AutoShipProductStyle } from './KitStyle.style';
import { addToCartMethod, isPercentageAssign } from '../../../Components/Common/CommonMethods';
import { useRouter } from 'next/router';

const KitSuccessPage = ({ cartdata, setCartData, kitSuccessProps, smartShipOnCart, ...props }) => {
    // const FrequentlyProduct = kitSuccessProps?.frequentlyProduct?.length > 0 && cartdata?.products[0]?.product?.frequently_bought_together
    const [cartNotify, setCartNotify] = useState('');
    const [percentage, setPercentage] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');

    const router = useRouter();
    useEffect(() => {
        setPercentage(isPercentageAssign())
    }, []);
    const FilterData = cartdata?.products?.filter((row) => row?.product?.is_custom_product)
    return (
        <>
            <div className='success page'>
                <i className="fa fa-check" aria-hidden="true"></i>
                <p>CONGRATULATIONS!</p>

                <p> You are one step closer to cracking your own code.</p><br />
                <p> Please mail your swabs promptly to the lab.</p><br />

                <p> You will be notified by e-mail when your results are ready.</p>
            </div>
            <AutoShipProductStyle>
                <div className='heading_section'>
                    <h2>Sign up for your customized CODE Complex™ supplement subscription and <span>SAVE up to $30 off</span></h2>
                    <p>You will not be charged for your supplement until your DNA data has been processed.</p>
                </div>
                <div className='autoshipProduct_section'>
                    {_.map(kitSuccessProps?.frequentlyProduct, (row, index) => {
                        let AUTOSHIP_PRICE = percentage ? row?.autoship_cost_price - row?.autoship_cost_price * (percentage / 100) : row?.autoship_cost_price;
                        let COST_PRICE = percentage ? row?.cost_price - row?.cost_price * (percentage / 100) : row?.cost_price;
                        return (
                            <div className='container_autoship' key={row?.id}>
                                {/* <label className="container">
                                <input type="checkbox" checked={+row?.id === kitSuccessProps?.checkedProduct} onChange={() => kitSuccessProps?.setCheckedProduct(+row?.id)} />
                                <span className="checkmark"></span>
                            </label> */}
                                <div className='image'>
                                    {row?.image && <img src={process.env.API_URL + row?.image} />}
                                </div>

                                <div className='name_and_price'><p>{row?.name}</p></div>
                                {(!(props?.subscribeAlready)) &&
                                    <div className="box">
                                        <div className="">
                                            <select className="form-select form-select-lg mb-3"
                                                value={(_.find(kitSuccessProps?.frequencyDate, { id: +row?.id })?.autoship)}
                                                onChange={(e) => kitSuccessProps?.setAutoshipFunction(e, row?.id)}>
                                                <option value="one-time">One Time</option>
                                                <option value="autoship">Subscription</option>
                                            </select>
                                        </div>
                                    </div>
                                }
                                {(_.find(kitSuccessProps?.frequencyDate)) &&
                                    <div className="main-qty-sections">
                                        <div id="qty">
                                            <button type="button" className="sub" onClick={() => kitSuccessProps?.onQtyfuntion('sub', +row?.id)}>-</button>
                                            <input name="1" readOnly type="text" value={_.find(kitSuccessProps?.quantity, { id: +row?.id })?.qty} onChange={(e) => console.log(e)} />
                                            <button type="button" className="add" onClick={() => kitSuccessProps?.onQtyfuntion('add', +row?.id)}>+</button>
                                        </div>
                                    </div>
                                }
                                <div className='amountSection'>
                                    <div>Price:</div>
                                    <div className=''>
                                        {(_.find(kitSuccessProps?.frequencyDate, { id: +row?.id })?.autoship === "one-time")
                                            ?
                                            <NumberFormatComp value={COST_PRICE} />
                                            :
                                            <NumberFormatComp value={AUTOSHIP_PRICE} />
                                        }
                                    </div>
                                </div>
                                <div className='submit_actions'>
                                    <button type="button" className='btn-primary-product' disabled={FilterData?.length > 0} onClick={() => {
                                        addToCartMethod(
                                            {
                                                id: row?.id,
                                                quantity: _.find(kitSuccessProps?.quantity, { id: row?.id })?.qty,
                                                is_autoship: _.find(kitSuccessProps?.frequencyDate, { id: row?.id })?.autoship === "autoship" ? true : false
                                            },
                                            props?.setshowminicart,
                                            setCartNotify,
                                            cartdata?.products,
                                            setCartData,
                                            false,
                                            setErrorMsg,
                                        )
                                        // setTimeout(() => router.push('/us/checkout/addresslist/'), 2000)
                                    }}>ADD TO CART</button>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {/* <div className='submit_actions'>
                    <button type="button" disabled={!(kitSuccessProps?.checkedProduct)} onClick={() => {
                        addToCartMethod(
                            {
                                id: kitSuccessProps?.checkedProduct,
                                quantity: _.find(kitSuccessProps?.quantity, { id: kitSuccessProps?.checkedProduct })?.qty,
                                is_autoship: _.find(kitSuccessProps?.frequencyDate, { id: kitSuccessProps?.checkedProduct })?.autoship === "autoship" ? true : false
                            },
                            props?.setshowminicart,
                            setCartNotify,
                            cartdata?.products,
                            setCartData
                        )
                        setTimeout(() => router.push('/us/checkout/addresslist/'), 2000)
                    }}>ADD TO CART</button>
                </div> */}
                {cartNotify && <span className='success'>{cartNotify}</span>}
            </AutoShipProductStyle>
        </>
    )
}

export default KitSuccessPage;